import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=1c1b342d&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1b342d')) {
      api.createRecord('1c1b342d', component.options)
    } else {
      api.reload('1c1b342d', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=1c1b342d&", function () {
      api.rerender('1c1b342d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/AccountSettings/Components/Sidebar.vue"
export default component.exports